import { render, staticRenderFns } from "./AddDashletComponent.vue?vue&type=template&id=54e13af5&scoped=true"
import script from "./AddDashletComponent.vue?vue&type=script&lang=js"
export * from "./AddDashletComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e13af5",
  null
  
)

export default component.exports